export default __webpack_public_path__ + "static/media/full_91x124.5aa620d2.svg";